// extracted by mini-css-extract-plugin
module.exports = {"icon":"CustomPanelItem_icon__I0TJl","row":"CustomPanelItem_row__h0Zu6"};